/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { useOidc, useOidcIdToken } from "@axa-fr/react-oidc";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LogOut = () => {
  const { isAuthenticated } = useOidc();
  const { idTokenPayload } = useOidcIdToken();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is authenticated, redirect to home
    if (isAuthenticated && idTokenPayload) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, idTokenPayload, navigate]);

  return null;
};

export default LogOut;
